module.exports = __webpack_public_path__ + "img/1557614092365144068.ae32824a.png";